
export default class Gift implements Activity.PackageGift {
    public choices: Equipment.ChoiceItem[];
    public choices_o: Equipment.ChoiceItem[];
    public id: number;
    public name: string;
    public price: number;
    public size_table: string | null;
    public spec_1: string | null;
    public spec_2: string | null;
    public spec_3: string | null;
    /** 为了和装备信息中的数据类型，以及保持只有一个数据源的情况下，手动填充该数据 */
    public specification: number | null;
    public confirm_word: string | null;
    public can_change_before: string;
    public order_id: number;
    public change_spec_days: number;
    /** 是否是只读选项（或者叫无法修改项） */
    public can_change: boolean;
    public image: string;
    public spec_map: Equipment.SpecMap;
    public type: string;

    public constructor(gift: Equipment.GiftItem) {
        // this.choices = gift.choices;
        this.choices = gift.choices.filter(ele => ((ele.left_count ?? 999) || (ele.left_count === 0 && ele.id === gift.specification ? 1 : 0)) > 0)
        this.choices_o = gift.choices
        this.price = gift.price;
        this.id = gift.id;
        this.name = gift.name;
        this.size_table = gift.size_table;
        this.spec_1 = gift.spec_1;
        this.spec_2 = gift.spec_2;
        this.spec_3 = gift.spec_3;
        this.specification = gift.specification;
        this.confirm_word = gift.confirm_word;
        this.can_change_before = gift.can_change_before;
        this.change_spec_days = gift.change_spec_days;
        this.can_change = gift.can_change;
        this.spec_map = gift.spec_map;
        this.image = gift.image;
        this.type = gift.type;
        this.order_id = gift.order_id;
    }

    public getSpec() {
        if (!this.specification) {
            return '';
        }
        for (const choice of this.choices) {
            if (choice.id === this.specification) {
                return [
                    this.spec_1 ? this.spec_1 + ':' : null,
                    choice.spec_1,
                    this.spec_2 ? this.spec_2 + ':' : null,
                    choice.spec_2,
                    this.spec_3 ? this.spec_3 + ':' : null,
                    choice.spec_3,
                ].filter((_) => _).join(' ');
            }
        }
        for (const choice of this.choices_o) {
            if (choice.id === this.specification) {
                return [
                    this.spec_1 ? this.spec_1 + ':' : null,
                    choice.spec_1,
                    this.spec_2 ? this.spec_2 + ':' : null,
                    choice.spec_2,
                    this.spec_3 ? this.spec_3 + ':' : null,
                    choice.spec_3,
                ].filter((_) => _).join(' ');
            }
        }
        return '';
    }
}
